import { useCallback, useState } from 'react';
import { readUiPreference, writeUiPreference, type UiPreferenceKey } from './ui-preferences';

/** 讀寫 localStorage 畫面偏好的 state hook；讀取失敗一律退回 fallback。 */
export function useUiPreference<T>(
  key: UiPreferenceKey,
  fallback: T,
): [T, (value: T | ((current: T) => T)) => void] {
  const [value, setValue] = useState<T>(() => readUiPreference(key, fallback));

  const update = useCallback(
    (next: T | ((current: T) => T)) => {
      setValue((current) => {
        const resolved = typeof next === 'function' ? (next as (current: T) => T)(current) : next;
        writeUiPreference(key, resolved);
        return resolved;
      });
    },
    [key],
  );

  return [value, update];
}
